export { default } from './TableSectionMobile';
